export function getCleanString(replaceStr: string): string {
  let built = Array.from(replaceStr.trim())
    .map(cleanCharacter)
    .filter(ch => ch !== '')
    .join('')

  while (built.includes('--')) {
    built = built.replace(/--/g, '-')
  }

  while (built.endsWith('-')) {
    built = built.substring(0, built.length - 1)
  }

  while (built.startsWith('-')) {
    built = built.substring(1)
  }

  return built.toLowerCase()
}

function cleanCharacter(ch: string): string {
  if (/\p{Nd}|\p{Nl}|\p{Ll}|\p{Lo}|\p{No}|\p{Lt}|\p{Lu}|\p{Pd}/u.test(ch)) {
    return ch
  }

  if (/\p{Zs}/u.test(ch)) {
    return '-'
  }

  if (/\p{Sm}|\p{Sk}|\p{Po}|\p{So}/u.test(ch)) {
    // Periods (and all other punctuation/symbol chars in these categories) are stripped,
    // not preserved: a '.' in a business name breaks the /pws/{businessName}/ URL routing.
    return ''
  }

  if (/\p{Ps}|\p{Pe}|\p{Cc}|\p{Me}|\p{Pf}|\p{Cf}|\p{Pi}|\p{Zl}|\p{Lm}|\p{Mn}|\p{Cn}|\p{Zp}|\p{Co}|\p{Mc}|\p{Cs}|\p{Pc}/u.test(ch)) {
    return ch === '_' ? ch : ''
  }

  return ''
}
